export default {
	namespaced: true,
	state: {
		bread_active: null,
		bread_list: null,
		userList: null,
		searchText: null,
		userInAssistance: {},
		formData: {},
		taskListData: [],
		coachTaskListData: [],
		teamTaskListData: [],
	},
	getters: {},
	mutations: {
		SET_DATA(state, data) {
			eval("state." + data.name + " = data.data;");
		}
	},
	actions: {
		searchUser(state, payload) {
			axios.get('/api/v2/searchUser/?q=' + payload.searchText)
				.then(response => {
					state.commit('SET_DATA', { name: 'userList', data: response.data.data });
				})
		},
		activeAssistance: function (state, payload) {
			axios.post('/api/v2/coach/activeAssistance', {
				userId: payload.id
			})
				.then(response => {
					state.dispatch('realTimeAssistance');
				})
		},
		checkAssistance(state, payload) {
			state.dispatch('destroyToken');
			axios.post('/oauth/token', {
				username: payload.email,
				password: payload.password,
				client_id: 2,
				client_secret: 'lZxWNLjGz7eHmc0Ner4ILkQDj0y5a6Y8Tolz8r7i',
				grant_type: 'password'
			})
				.then(response => {
					localStorage.setItem("access_token", response.data.access_token);
					axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.access_token;
					window.location.href = '/login_cr'; // Avoid WordPress
				})
				.catch(() => {

				})
		},
		realTimeAssistance(state) {
			axios.get('/api/v2/coach/realTimeAssistance')
				.then(response => {
					state.commit('SET_DATA', { name: 'userInAssistance', data: response.data });
					state.dispatch('taskList', { userId: state.state.userInAssistance.id });
				})
		},

		removeAssistance(state) {
			axios.get('/api/v2/coach/removeAssistance')
				.then(response => {
					state.dispatch('realTimeAssistance');
				})
		},

		onSubmit(state) {
			axios.post('/api/v2/coach/saveTask', {
				task: state.state.formData.task,
				date: state.state.formData.date,
				user_id: state.state.userInAssistance.id
			})
				.then(response => {
					state.dispatch('taskList', { userId: state.state.userInAssistance.id })
				})
		},
		
		taskList(state, payload) {
			axios.get('/api/v2/coach/taskList/' + payload.userId)
				.then(response => {
					state.commit('SET_DATA', { name: 'coachTaskListData', data: response.data.coachTaskList });
					state.commit('SET_DATA', { name: 'taskListData', data: response.data.taskList });
					state.commit('SET_DATA', { name: 'teamTaskListData', data: response.data.teamTaskList });
				})
		},

		taskChangeStatus(state, payload) {
			axios.get('/api/v2/coach/task/' + payload.id + '/changeStatus')
				.then(response => {
					state.dispatch('taskList', payload);
				})
		},

		teamTaskChangeStatus(state, payload) {
			axios.get('/api/v2/coach/task/' + payload.id + '/teamTaskChangeStatus')
				.then(response => {
					state.dispatch('taskList', payload);
				})
		}

	}
}
